import { render, staticRenderFns } from "./TituloHero.vue?vue&type=template&id=6175da7a&scoped=true"
import script from "./TituloHero.vue?vue&type=script&lang=js"
export * from "./TituloHero.vue?vue&type=script&lang=js"
import style0 from "./TituloHero.vue?vue&type=style&index=0&id=6175da7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6175da7a",
  null
  
)

export default component.exports